<template>
    <div>
        <div class="back" v-if="isVisible" @click="hideModal"></div>
        <div class="serviceView" v-if="isVisible">
            <div class="modalView_pop">
                <div class="modalView_pop_l">
                    <div class="modalView_pop_l_view">
                        <div class="modalView_pop_l_view_t">
                            <div class="modalView_pop_l_view_t_1">
                                <div class="modalView_pop_l_view_t_3_text">{{ $t('orderI18n.title') }}</div>
                            </div>
                            <div class="modalView_pop_l_view_t_2">{{ $t('orderI18n.desc') }}</div>
                        </div>
                        <div class="modalView_pop_l_view_b">
                            <div class="modalView_pop_l_view_b_2">
                                <div class="modalView_pop_r_2_choose">
                                    <div class="modalView_pop_r_2_choose_v"
                                        v-for="item in productList"
                                        :key="item.value"
                                    >
                                        <input 
                                            class="modalView_pop_r_2_choose_v_input" 
                                            type="radio" 
                                            name="product" 
                                            :value="item.name" 
                                            v-model="selectProduct"
                                        >
                                        <span>{{ $t(item.name) }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="modalView_pop_l_view_b_table">
                                <el-table
                                    :data="tableData"
                                    height="100%"
                                    border
                                    v-loading="loading"
                                    style="width: 100%"
                                    :row-style="rowStyle"
                                    @row-click="handleRowClick"
                                >
                                    <el-table-column
                                        prop="id"
                                        :label= "$t('orderI18n.number')"
                                        align="center"
                                        :class-name="getHeaderClass($t('orderI18n.number'))"
                                    >
                                        <template slot-scope="scope">
                                            {{ scope.$index + 1 }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        prop="id"
                                        :label="$t('orderI18n.id')"
                                        align="center"
                                        width="150"
                                        :class-name="getHeaderClass($t('orderI18n.id'))"
                                    >
                                    </el-table-column>
                                    <el-table-column
                                        prop="origin_order_id"
                                        :label="$t('orderI18n.origin_order_id')"
                                        align="center"
                                        width="150"
                                        :class-name="getHeaderClass($t('orderI18n.origin_order_id'))"
                                    >
                                    </el-table-column>
                                    <el-table-column
                                        prop="permission.id"
                                        :label="$t('serviceI18n.service_id')"
                                        align="center"
                                        width="150"
                                        class-name="wrap-header"
                                    >
                                    </el-table-column>
                                    <el-table-column
                                        prop="feature"
                                        :label="$t('orderI18n.feature')"
                                        align="center"
                                        :class-name="getHeaderClass($t('orderI18n.feature'))"
                                    >
                                        <template slot-scope="scope">
                                            {{ scope.row.feature.title }}
                                        </template>
                                    </el-table-column>
                                    <template v-if="getSelectedProductValue() === 'tpc'">
                                        <el-table-column
                                            prop="config"
                                            :label="$t('orderI18n.scope')"
                                            align="center"
                                            :class-name="getHeaderClass($t('orderI18n.scope'))"
                                        >
                                            <template slot-scope="scope">
                                                {{ getScopeName(scope.row.permission_config?.scope) }}
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                            prop="config"
                                            :label="$t('orderI18n.address_limit')"
                                            align="center"
                                            :class-name="getHeaderClass($t('orderI18n.address_limit'))"
                                        >
                                            <template slot-scope="scope">
                                                {{ scope.row.permission_config?.address_limit }}
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                            prop="config"
                                            :label="$t('orderI18n.source_limit')"
                                            align="center"
                                            :class-name="getHeaderClass($t('orderI18n.source_limit'))"
                                        >
                                            <template slot-scope="scope">
                                                {{ scope.row.permission_config?.source_limit == 0 ? "≤100" : scope.row.permission_config?.source_limit == 1 ? "101-500" : scope.row.permission_config?.source_limit == 2 ? "＞500" :'' }}
                                            </template>
                                        </el-table-column>
                                    </template>
                                    <template v-else-if="getSelectedProductValue() === 'tzj'">
                                        <el-table-column
                                            prop="config"
                                            label="排放源数量"
                                            align="center"
                                        >
                                            <template slot-scope="scope">
                                                {{ scope.row.permission_config?.source_limit == 0 ? "≤20" : scope.row.permission_config?.source_limit == 1 ? "＞20" :'' }}
                                            </template>
                                        </el-table-column>
                                    </template>
                                    <el-table-column
                                        prop="amount"
                                        :label="$t('orderI18n.amount')"
                                        align="center"
                                        :class-name="getHeaderClass($t('orderI18n.amount'))"
                                    >
                                    </el-table-column>
                                    <el-table-column
                                        prop="status"
                                        :label="$t('orderI18n.status')"
                                        align="center"
                                        :class-name="getHeaderClass($t('orderI18n.status'))"
                                    >
                                        <template slot-scope="scope">
                                            {{ getStatusName(scope.row.status) }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        prop="payment_time"
                                        :label="$t('orderI18n.payment_time')"
                                        align="center"
                                        :class-name="getHeaderClass($t('orderI18n.payment_time'))"
                                    >
                                        <template slot-scope="scope">
                                            {{ scope.row.payment_time ? $dayjs(scope.row.payment_time).format('YYYY-MM-DD HH:mm:ss') : '' }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        prop="payment_method"
                                        :label="$t('orderI18n.payment_method')"
                                        align="center"
                                        :class-name="getHeaderClass($t('orderI18n.payment_method'))"
                                    >
                                        <template slot-scope="scope">
                                            {{ getPaymentMethodName(scope.row.payment_method) }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        prop="invoice_status"
                                        :label="$t('orderI18n.invoice_status')"
                                        align="center"
                                        :class-name="getHeaderClass($t('orderI18n.invoice_status'))"
                                    >
                                        <template slot-scope="scope">
                                            {{ getInvoiceStatusName(scope.row.invoice_status) }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        prop="created_at"
                                        :label="$t('orderI18n.created_at')"
                                        align="center"
                                        :class-name="getHeaderClass($t('orderI18n.created_at'))"
                                    >
                                        <template slot-scope="scope">
                                            {{ $dayjs(scope.row.created_at).format('YYYY-MM-DD HH:mm:ss') }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        :label="$t('orderI18n.action')"
                                        align="center"
                                        width="140"
                                        :class-name="getHeaderClass($t('orderI18n.action'))"
                                    >
                                        <template slot-scope="scope">
                                            <div class="tableBtnView" v-if="scope.row.status === 'UNPAID'">
                                                <el-button @click="handlePay(scope.row)" type="text" size="small">{{$t('orderI18n.pay')}}</el-button>
                                                <el-button @click="handleCancel(scope.row)" type="text" size="small">{{ $t('orderI18n.cancel') }}</el-button>
                                            </div>
                                            <div 
                                                v-else-if="scope.row.status == 'PAID' || 
                                                scope.row.status == 'REFUNDED' || 
                                                scope.row.status == 'REFUNDING' || 
                                                scope.row.status == 'UPGRADED'"
                                                class="tableBtnView"
                                            >
                                                <el-button @click="handleDownLoad(scope.row)" type="text" size="small">{{$t('orderI18n.download')}}</el-button>
                                            </div>
                                            <div v-if="scope.row.invoice_status === 'UNINVOICED' && scope.row.status !== 'UNPAID'">
                                                <el-button @click="handleApplyInvoice(scope.row)" type="text" size="small">{{$t('orderI18n.apply_invoice')}}</el-button>
                                            </div>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                            <div class="modalView_pop_l_view_b_page">
                                <el-pagination
                                    @current-change="handleCurrentChange"
                                    :current-page.sync="currentPage"
                                    :page-size="25"
                                    layout="prev, pager, next"
                                    :total="totalNum">
                                </el-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ChooseProduct ref="chooseProduct" @update="updateList"/>
        <!-- 邮箱 -->
        <el-dialog
            :title="$t('orderI18n.apply_invoice')"
            :visible.sync="fpVisible"
            width="380px"
            :modal-append-to-body="false"
            :close-on-click-modal="false"
            custom-class="custom-dialog"
            :before-close="() => (fpVisible = false)"
            center
            top="30vh"
        >
            <div class="dialog-content-order">
                <div class="dialog-text-order">{{$t('orderI18n.invoice_type')}}</div>
                <el-radio-group v-model="invoice_type" class="demo-radio-group">
                    <el-radio :label="0">{{$t('orderI18n.invoice_type_list[0].name')}}</el-radio>
                    <el-radio :disabled="!showZp" :label="1">{{$t('orderI18n.invoice_type_list[1].name')}}</el-radio>
                </el-radio-group>
                <div class="dialog-text-order">{{$t('orderI18n.invoice_email_placeholder')}}</div>
                <el-input
                    v-model="invoice_email"
                    :placeholder="$t('orderI18n.invoice_email_placeholder')"
                    maxlength="45"
                    class="custom-input"
                    show-word-limit
                />
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button
                    @click="fpVisible = false"
                    class="custom-cancel-btn"
                >
                    {{$t('orderI18n.cancelBtn')}}
                </el-button>
                <el-button
                    type="primary"
                    @click="handleSubmit"
                    class="custom-confirm-btn"
                >
                    {{$t('orderI18n.confirmBtn')}}
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getOwnerFeatures, getOrderList, downloadContractFile, cancelOrder, applyInvoice } from '@/api/index';
import ChooseProduct from './ChooseProduct';
import { mapState, mapMutations } from "vuex";
export default {
  components: {
    ChooseProduct
  },
  data() {
    return {
        isVisible: false, // 控制弹窗的显示状态
        productList:[
            {
                name: this.$t('orderI18n.feature_title.tpc'),
                value: "tpc"
            },
            {
                name: this.$t('orderI18n.feature_title.tzj'),
                value: "tzj"
            },
            // {
            //     name: this.$t('orderI18n.feature_title.esg'),
            //     value: "esg"
            // }
        ],
        selectProduct:"",
        currentRowId: null, // 当前点击的行ID
        productInfo:null,
        tableData: [],
        totalNum:0,
        currentPage: 1,
        loading: false,
        fpVisible:false,
        invoice_email: this.userInfo?.email || "",
        invoice_type: 0,
        showZp: true,
    }
  },
  methods: {
    ...mapMutations(["setOrderInfo"]),

    // 表头判断
    getHeaderClass(label) {
      // 判断内容是否包含英文
      const hasEnglish = /[a-zA-Z]/.test(label);
      return hasEnglish ? 'no-wrap-header' : 'wrap-header';
    },

    // 获取选中的产品值
    getSelectedProductValue() {
      const selectedProduct = this.productList.find(item => item.name === this.selectProduct);
      return selectedProduct ? selectedProduct.value : '';
    },

    // 获取范围名称
    getScopeName(scope) {
      switch (scope) {
        case 0:
          return this.$t('orderI18n.scope_list[0].name');
        case 1:
          return this.$t('orderI18n.scope_list[1].name');
        default:
          return '';
      }
    },

    // 获取状态名称
    getStatusName(status) {
      if (status === null || status === undefined || status === '') return '';
      const found = this.$t('orderI18n.status_list').find(item => item.value === status);
      return found ? found.name : '';
    },

    // 获取支付方式名称
    getPaymentMethodName(method) {
      switch (method) {
        case 'alipay':
          return this.$t('orderI18n.payment_method_list[0].name');
        case 'wechat':
          return this.$t('orderI18n.payment_method_list[1].name');
        case 'b2b':
          return this.$t('orderI18n.payment_method_list[2].name');
        case 'system':
          return this.$t('orderI18n.payment_method_list[3].name');
        default:
          return '';
      }
    },

    // 获取发票状态名称
    getInvoiceStatusName(status) {
      switch (status) {
        case "UNINVOICED":
          return this.$t('orderI18n.invoice_status_list[0].name');
        case "INVOICING":
          return this.$t('orderI18n.invoice_status_list[1].name');
        case "INVOICED":
          return this.$t('orderI18n.invoice_status_list[2].name');
        case "REVERSING":
          return this.$t('orderI18n.invoice_status_list[3].name');
        case "REVERSED":
          return this.$t('orderI18n.invoice_status_list[4].name');
        default:
          return '';
      }
    },

    showModal() {
        this.isVisible = true; // 假设 isVisible 控制弹窗的显示状态
        document.body.style.overflow = 'hidden'; // 禁止页面滚动
    },

    hideModal() {
        this.isVisible = false; // 假设 isVisible 控制弹窗的显示状态
        document.body.style.overflow = ''; // 恢复页面滚动  
    },

    //更新列表
    updateList(){
        this.currentPage = 1
        this.loadList()
    },

    // 根据选中的产品从 getOwnerFeatures 获取 feature_id
    async getFeatureIdByProduct() {
        const code = this.getSelectedProductValue();
        if (!code) return null;
        const res = await getOwnerFeatures();
        if (res.data) {
            const feature = res.data.data.find(item => item.code === code);
            return feature ? feature.id : null;
        }
        return null;
    },

    // 获取订单列表
    async loadList() {
        this.loading = true;
        try {
            const featureId = await this.getFeatureIdByProduct();
            const params = {
                page: this.currentPage,
                limit: 25,
                feature_id: featureId
            };
            const res = await getOrderList(params);
            if (res.data.code === 200) {
                this.tableData = res.data.data.items || [];
                this.totalNum = res.data.data.total;
            } else {
                this.$message.error(res.data.msg || this.$t('orderI18n.message.load_error'));
                this.hideModal();
            }
        } catch (error) {
            this.$message.error(error || this.$t('orderI18n.message.load_error'));
            this.hideModal();
        } finally {
            this.loading = false;
        }
    },

    // 当前页处理
    handleCurrentChange(val) {
        this.currentPage = val;
        this.loadList()
    },

    // 选择产品服务
    chooseProduct(value) {
        if (this.selectProduct !== value) {
            this.selectProduct = value;
            this.loadList();
        }
    },

    // 防止取消选择
    preventUnselect(event, value) {
        if (this.selectProduct === value) {
            event.preventDefault();
        }
    },

    // 处理支付
    handlePay(row) {
        this.$refs.chooseProduct.showModal(row, 2);
    },

    // 处理取消订单
    handleCancel(row) {
        this.$confirm(this.$t('orderI18n.message.cancel_order_confirm'), this.$t('orderI18n.tips'), {
            confirmButtonText: this.$t('orderI18n.confirmBtn'),
            cancelButtonText: this.$t('orderI18n.cancelBtn'),
            type: 'warning'
        }).then(() => {
            cancelOrder(row.id).then((res) => {
                if (res.data.code === 200) {
                    this.$message.success(this.$t('orderI18n.message.cancel_success'));
                    this.loadList();
                } else {
                    this.$message.error(res.data.msg || this.$t('orderI18n.message.cancel_fail'));
                }
            }).catch((error) => {
                this.$message.error(error || this.$t('orderI18n.message.cancel_fail'));
            });
        });
    },

    //合同下载
    handleDownLoad(row){
        downloadContractFile(row.contract.id).then((res) => {
            if (res.data) {
                const blob = new Blob([res.data], { type: 'application/pdf' });
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = row.contract.file_name;
                a.click();
            } else {
                this.$message.error(res.data.msg || this.$t('orderI18n.message.download_fail'));
            }
        }).catch((error) => {
            this.$message.error(error || this.$t('orderI18n.message.download_fail'));
        });
    },

    //申请开票
    handleApplyInvoice(row){
        this.fpVisible = true;
        if(row.credit_code == ''){
            this.showZp = false;
        }else{
            this.showZp = true;
        }
    },
    
    // 处理提交
    handleSubmit(){
        if(!this.invoice_email){
            this.$message.error(this.$t('orderI18n.invoice_email_placeholder'));
            return;
        }
        applyInvoice(this.currentRowId, {
            invoice_email: this.invoice_email,
            invoice_type: this.invoice_type
        }).then((res) => {
            if (res.data.code === 200) {
                this.$message.success(this.$t('orderI18n.message.apply_invoice_success'));
                this.invoice_type = 0;
                this.loadList();
            } else {
                this.$message.error(res.data.data || this.$t('orderI18n.message.apply_invoice_fail'));
            }
            this.fpVisible = false;
        }).catch((error) => {
            this.fpVisible = false;
            this.$message.error(error || this.$t('orderI18n.message.apply_invoice_fail'));
        });
    },

    // 处理行点击事件
    handleRowClick(row) {
        this.currentRowId = row.id; // 更新当前点击的行ID
    },

    // 行样式
    rowStyle({ row }) {
        if (this.currentRowId === row.id) {
            return { 'background': '#D1ECFD', 'color': '#000', 'font-weight': '700' }; // 返回选中行的样式
        }
        return {};
    },
  },
  computed: {
    ...mapState(["userInfo", "orderInfo"]),
  },
  mounted() {
    if(this.productList.length > 0){
        this.selectProduct = this.productList[0].name;
    }
  },
  created() {
    this.$watch("isVisible", (val) => {
      if (val) {
        this.loadList();
      }
    });
  },
  watch: {
    userInfo: {
      handler(newVal) {
        this.invoice_email = newVal?.email || "";
      },
      immediate: true,
      deep: true
    },
    selectProduct(newVal, oldVal) {
        if (newVal !== oldVal && this.isVisible) { // 只有在弹窗打开时才加载
            this.currentPage = 1;
            this.loadList();
        }
    }
  },
}
</script>

<style scoped lang="scss">
.back{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background: rgba(33, 33, 33, 0.5);
    height: 100vh;
    z-index: 999;
}
.serviceView {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    // background: linear-gradient(180deg, #7AE495 0%, #56C697 50%, #339E9E 100%);
    background: var(--global-background);
    width: 1200px;
    height: 650px;
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    z-index: 1001;

    .modalView_pop {
        width: calc(100% - 20px);
        height: calc(100% - 20px);
        background-color: #ffffff; /* 设置不透明的白色底色 */
        background-image: var(--global-inner-background);
        border-radius: 20px;
        display: flex;

        .modalView_pop_l {
            width: 1100px;
            height: 100%;
            position: relative;

            .modalView_pop_l_view {
                width: 100%;
                height: 100%;
                margin: 0 10px 0 35px;
                border-left: 2px dashed #E3E6E8;
                border-right: 2px dashed #E3E6E8;

                .modalView_pop_l_view_t {
                    width: 100%;
                    border-bottom: 2px dashed #E3E6E8;
                    height: 140px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    

                    .modalView_pop_l_view_t_1 {
                        width: 223px;
                        height: 46px;
                        margin-left: 33px;                   

                        .modalView_pop_l_view_t_3_text{
                            font-size: 35px;
                            color: rgba(33, 33, 33, 1);
                            font-weight: 500;
                        }
                    }

                    .modalView_pop_l_view_t_2 {
                        font-size: 18px;
                        color: rgba(0, 0, 0, 1);
                        font-weight: 500;
                        margin-left: 35px;
                        letter-spacing: 3px;
                        // margin-top: 10px;
                    }
                }

                .modalView_pop_l_view_b {
                    width: 100%;
                    height: calc(100% - 160px);
                    position: relative;

                    .modalView_pop_l_view_b_2{
                        margin:20px 10px 30px 33px;
                        height: auto;
                        overflow-y: hidden; 

                        .modalView_pop_r_2_choose{
                          height: 40px;
                          width: 100%;
                          display: flex;
                          align-items: center;

                            .modalView_pop_r_2_choose_v{
                                height: 100%;
                                display: flex;
                                align-items: center;
                                margin-right: 50px;

                                .modalView_pop_r_2_choose_v_input{
                                    appearance: none; /* 隐藏默认样式 */
                                    width: 25px;
                                    height: 25px;
                                    border: 1px solid #757575;
                                    border-radius: 50%;
                                    margin-right: 10px;
                                    position: relative;
                                    cursor: pointer;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                }

                                .modalView_pop_r_2_choose_v_input:checked {
                                    border-color: #757575;
                                    background-color: #fff;
                                }

                                ::v-deep .modalView_pop_r_2_choose_v_input:checked:after {
                                    content: '';
                                    position: absolute;
                                    top: 50%;
                                    left: 50%;
                                    transform: translate(-50%, -50%);
                                    width: 17px!important; /* 圆点大小 */
                                    height: 17px!important;
                                    border-radius: 50%;
                                    background-color: #757575; /* 圆点颜色 */
                                }

                                span{
                                    font-size: 20px;
                                    font-weight: 700;
                                    color: rgba(0, 0, 0, 1);
                                }
                            }
                        }
                    }

                    .modalView_pop_l_view_b_table{
                        margin: 0 33px auto;
                        overflow-y: auto; /* 启用垂直滚动条 */
                        padding-right: 10px; /* 为滚动条预留空间，避免内容被遮挡 */
                        scrollbar-width: thin; /* 优化滚动条宽度（Firefox） */
                        scrollbar-color: rgba(117, 117, 117, 0.5) transparent;
                        height: calc(100% - 100px);
                        

                        ::v-deep .el-table, 
                        ::v-deep .el-table__expanded-cell {
                            background-color: transparent;
                            border-color: rgba(58, 83, 36, 0.75)!important;
                        }

                        ::v-deep .no-wrap-header .cell{
                            word-break: keep-all;
                        }

                        ::v-deep .wrap-header .cell{
                            white-space: normal; 
                        }

                        ::v-deep .el-table--border{
                            background-color: transparent!important;
                            border-color: rgba(58, 83, 36, 0.75)!important;
                            border: 1px solid rgba(58, 83, 36, 0.75)!important;
                        }

                        /* 表格内背景颜色 */
                        ::v-deep .el-table th,
                        ::v-deep .el-table tr,
                        ::v-deep .el-table td {
                            background: transparent;
                            border-color: rgba(58, 83, 36, 0.75)!important;
                        }

                        /* 设置点击行的渐变色背景 */
                        ::v-deep .el-table__body tr.current-row > td {
                            // background: linear-gradient(180deg, #DEFFE7 0%, #DBFFF0 50%, #DBFFFF 100%) !important;
                            background: #00D6B9!important;
                            color: #000 !important; /* 设置文字颜色为黑色 */
                            font-weight: 700 !important;
                        }

                        .tableBtnView{
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: center;
                        }

                        .el-button+.el-button, .el-checkbox.is-bordered+.el-checkbox.is-bordered{
                            margin: 0;
                        }
                    }

                    .modalView_pop_l_view_b_page{
                        display: flex;
                        align-items: center;
                        justify-content: flex-end;
                    }
                }
            }
        }
    }
}

.dialog-content-order{
    text-align: left;
    .dialog-text-order{
        font-size: 16px;
        color: rgba(0, 0, 0, 1);
        font-weight: 500;
    }

    .demo-radio-group{
        font-size: 16px;
        margin-bottom: 30px;

        ::v-deep .el-radio__input{
            font-size: 16px!important;
        }
    }
}

/* 如果使用scoped，可能需要调整选择器，例如使用深度选择器 >>> */
*[innerHTML*="<br>"] {
    display: inline-block;
    text-indent: 0;
}
*[innerHTML*="<br>"] br + * {
    display: block;
    text-indent: 2em;
}
</style>